const getForceThemeParam = (): string | null => {
  const params = new URLSearchParams(window.location.search);
  return params.get('forceTheme');
};

export const isForceDarkTheme = (): boolean => {
  return getForceThemeParam() === 'dark';
};

export const isForceLightTheme = (): boolean => {
  return getForceThemeParam() === 'light';
};
